// Ranks displays as levels/columns on sankey diagram
export const sankeyRankColumns = ["root", "superkingdom", "kingdom", "phylum", "class", "order", "family", "genus", "species"];